import gql from 'graphql-tag';

export const SEARCH_COMMENTS = gql`
  query searchComments ($idValue: String!) {
    SearchComments(text:$idValue) {
      id,
      text
    }
  }
`;

export const CREATE_COMMENT = gql`
  mutation createComment (
    $id: ID,
    $text: String,
    $creationDate: _Neo4jDateTimeInput
  ) {
  CreateComment(
    id: $id,
    text: $text,
    creationDate: $creationDate
  ) {
    id,
    text,
    creationDate { formatted }
  }
}
`;

export const CREATE_COMMENT_ON_COMMENTABLE_WITH_AUTHOR = gql`
  mutation createCommentOnCommentableWithAuthor (
    $text: String!,
    $onId: ID!,
    $authorId: ID!
  ) {
    AddCommentOnCommentableWithAuthor(
      text: $text,
      onId: $onId,
      authorId: $authorId
      ) {
        id,
        text,
        creationDate { formatted },
        lastModifiedDate { formatted },
        author {
          id,
          accountId,
          fullName,
          imageDepictions {
          id,
          title,
          type,
          thumbnail { 
            id, 
            file {
              mimeType, 
              uri 
              }
            }
          }
        }
      }
  }
`;

export const UPDATE_COMMENT = gql`
  mutation updateComment (
    $personId: ID!,
    $input: CommentInput
  ) {
    UpdateComment(
      personId: $personId,
      input: $input
  ) {
    id,
    text,
    creationDate { formatted },
    lastModifiedDate { formatted }
    author {
      id,
      accountId,
      fullName,
      imageDepictions {
      id,
      title,
      type,
      thumbnail { 
        id, 
        file {
          mimeType, 
          uri 
          }
        }
      }
    }
  }
}
`;

export const DELETE_COMMENT = gql`
  mutation deleteComment (
    $personId: ID!,
    $commentId: ID!
  ) {
  DeleteComment(
      personId: $personId,
      commentId: $commentId
  ) {
    id
  }
}
`;

export const ADD_COMMENT_COMMENTABLE = gql`
  mutation addCommentCommentable (
      $commentId: ID!
      $commentableId: ID!
    ) {
    AddCommentCommentable (
      commentId: $commentId
      commentableId: $commentableId
    ){
      id
    }
  }
`;

export const REMOVE_COMMENT_COMMENTABLE = gql`
  mutation removeCommentCommentable (
      $commentId: ID!
      $commentableId: ID!
    ) {
    RemoveCommentCommentable (
      commentId: $commentId
      commentableId: $commentableId
    ){
      id
    }
  }
`;

export const ADD_COMMENT_AUTHOR = gql`
  mutation addCommentAuthor (
    $from: _PersonInput!
    $to: _CommentInput!
  ) {
  AddCommentAuthor(
    from: $from
    to: $to
  ) {
    from { id }
    to { id }
    }
  }
`;

// AddCommentAuthor(
//   from: _PersonInput!
//   to: _CommentInput!
// ): _AddCommentAuthorPayload
// RemoveCommentAuthor(
//   from: _PersonInput!
//   to: _CommentInput!
// ): _RemoveCommentAuthorPayload
// AddCommentContribution(
//   from: _CommentInput!
//   to: _ContributionInput!
// ): _AddCommentContributionPayload
// RemoveCommentContribution(
//   from: _CommentInput!
//   to: _ContributionInput!
// ): _RemoveCommentContributionPayload
// AddCommentProject(
//   from: _CommentInput!
//   to: _ProjectInput!
// ): _AddCommentProjectPayload
// RemoveCommentProject(
//   from: _CommentInput!
//   to: _ProjectInput!
// ): _RemoveCommentProjectPayload
